const $ = window.jQuery;

const Nav = {

    init() {
        var $burger = $(document).find('.burger button');
        if (!$burger.length)
            return;

        var $toggleBbutton = $(document).find('.toggle-button');

                // Toggle sub-menus
        $toggleBbutton.on('click', function (){
            $(this).parent().toggleClass("menu-collapsed");
            $(this).toggleClass("tgl-active");
        });
  
        $burger.on('click', function() {
            $(this).toggleClass('active');
            $('nav.main ').toggleClass('mobile-active');
        });

   
    },

 

};

export default Nav;